import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../Constant";
import Slider from "react-slick";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Image, Row, Typography, Space, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getBannerApi } from "../../Features/Banner/Banner";

import {
  getProductAllApi,
  getProductFeatureList,
  getProductListData2,
  getProductListData3,
} from "../../Features/Product/Product";
import { getSettingApi } from "../../Features/Setting/Setting";
import { getProfileApi } from "../../Features/User/User";
import { getCategoryFeatureApi } from "../../Features/Category/Category";
import { getWishListApi } from "../../Features/WishList/WishList";

import styles from "./index.module.scss";
import BannerCarousel, { DEFAULT_TRANSITION, DEFAULT_INTERVAL_MS } from "../../Component/BannerCarousel/BannerCarousel";
import { getSpecificationApi } from "../../Features/Specification/Specification";
import { ProductCard } from "../../Component/productCard";
import { buildCategoryPath, slugify, normalizeProductPath } from "../../utils/categoryUrl";
import {
  DollarOutlined,
  CrownOutlined,
  AppstoreOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";
import about from "../../Assets/PNG/about.jpg";
import najLogo from "../../Assets/PNG/naj.png";

const brands = [
  "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Garmin_logo_2006.svg/1200px-Garmin_logo_2006.svg.png",
  "https://images-aka.ernestjones.co.uk/Homepage/logos/01_330x120_EJ2310W07_Homepage_Logos_boss_v2.jpg",
  "https://images-aka.ernestjones.co.uk/Homepage/logos/330x120_EJ2504W01_Tissot.jpg",
  "https://images-aka.ernestjones.co.uk/Homepage/images/brand-logos/03_330x120_EJ2310W07_Homepage_Logos_longines.jpg",
  "https://images-aka.ernestjones.co.uk/Homepage/images/brand-logos/02_330x120_EJ2310W07_Homepage_Logos_gucci.jpg",
  "https://images-aka.ernestjones.co.uk/campaigns/2024/gift_with_purchase/330x120_EJ2310WC14_Tudor.jpg",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Garmin_logo_2006.svg/1200px-Garmin_logo_2006.svg.png",
];

const PoundIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path d="M15 4H9.5C8.1 4 7 5.1 7 6.5V10H13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 14H17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M7 10H5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M7 19H17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M7 10V19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const GemIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path d="M12 3L2 9L12 21L22 9L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M2 9H22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M12 3L7.5 9L12 21" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M12 3L16.5 9L12 21" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
  </svg>
);

const CollectionIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.8"/>
    <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.8"/>
    <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.8"/>
    <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" stroke="currentColor" strokeWidth="1.8"/>
  </svg>
);

const SupportIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
  </svg>
);

const FeatureSection = () => {
  const features = [
    {
      icon: <PoundIcon />,
      title: "Dynamic Pricing",
      desc: "Our pricing evolves with the gold market, offering complete transparency while ensuring every piece reflects exceptional value and uncompromising quality.",
    },
    {
      icon: <GemIcon />,
      title: "Exceptional Craftsmanship",
      desc: "Our jewellery is carefully crafted by skilled artisans, combining traditional techniques with thoughtful design to create pieces of lasting beauty and character.",
    },
    {
      icon: <CollectionIcon />,
      title: "Extensive Collection",
      desc: "We present a carefully curated range of timeless and contemporary designs, offering versatility to suit different styles, occasions, and individual preferences.",
    },
    {
      icon: <SupportIcon />,
      title: "Reliable Support & Delivery",
      desc: "We provide attentive customer support and dependable delivery services, ensuring every order is handled with care and efficiency.",
    },
  ];

  return (
    <Col xs={24} className={styles.featureSection}>
      <div className={styles.featureOverlay} />
      <div className={styles.featureContent}>
        <div className={styles.featureHeadingBlock}>
          <span className={styles.featureEyebrow}>The Diamond Counter Difference</span>
          <h2 className={styles.featureHeading}>Why Choose Us</h2>
          <div className={styles.featureHeadingLine} />
        </div>

        <div className={styles.featureGrid}>
          {features.map((item, index) => (
            <div className={styles.featureCard} key={index}>
              <div className={styles.featureIconRing}>{item.icon}</div>
              <h3 className={styles.featureCardTitle}>{item.title}</h3>
              <p className={styles.featureCardDesc}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};

function Home() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Title, Text, Paragraph } = Typography;
  // const { SpecificationData } = useSelector((state) => state.specification);

  const allProducts = useSelector((state) => state.product?.productAllData);

  const userid = useSelector((state) => state.user?.userId);
  const userToken = useSelector((state) => state.user?.token);
  const banner = useSelector((state) => state.banner?.bannerData);

  // Feature tiles below the main banner — admin-managed via /admin/banners
  // (Feature Tiles tab). Top 4 link into Product Range, bottom 4 link into
  // Branded Jewellery. Only active tiles render, in their position order.
  const [featureTiles, setFeatureTiles] = useState([]);
  useEffect(() => {
    axios.get(`${BASE_URL}/feature-tiles/get`)
      .then(r => setFeatureTiles(r?.data?.data || []))
      .catch(() => setFeatureTiles([]));
  }, []);

  // Banner carousel transition — admin sets it via /admin/banners
  // (Banners tab → "Carousel transition" selector). Stored as
  // /menu/banner_transition.
  const [bannerTransition, setBannerTransition] = useState(DEFAULT_TRANSITION);
  const [bannerIntervalMs, setBannerIntervalMs] = useState(DEFAULT_INTERVAL_MS);
  useEffect(() => {
    axios.get(`${BASE_URL}/menu/banner_transition`)
      .then(r => {
        const t = r?.data?.data?.transition;
        const ms = r?.data?.data?.intervalMs;
        if (typeof t === "string" && t) setBannerTransition(t);
        if (Number.isFinite(ms) && ms > 0) setBannerIntervalMs(ms);
      })
      .catch(() => {});
  }, []);

  // Hide bottom 4 (branded) tiles if retailer has Show_Branded_Menu off
  const showBranded = (() => {
    try {
      const s = JSON.parse(localStorage.getItem("tdc_retailer_settings") || "{}");
      return s.Show_Branded_Menu !== false;
    } catch { return true; }
  })();
  const visibleTiles = featureTiles
    .filter(t => t.isActive && t.image)
    .filter(t => showBranded ? true : t.position <= 4);

  const { productList2, productList3 } = useSelector(
    (state) => state.product,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getProductAllApi());
    dispatch(getCategoryFeatureApi());
    dispatch(getSpecificationApi());

    dispatch(getBannerApi());
    dispatch(getWishListApi(userToken));
    dispatch(getProfileApi(userToken));
    dispatch(getSettingApi());

    const safeUserId = userid ?? 0;

    dispatch(
      getProductFeatureList({
        userId: safeUserId,
        homeFeature: 2,
        successAction: getProductListData2,
      }),
    );
    dispatch(
      getProductFeatureList({
        userId: safeUserId,
        homeFeature: 3,
        successAction: getProductListData3,
      }),
    );
  }, []);

  const handleAddCart = (id, name) => {
    navigate(`/product-detail/${slugify(name)}`, {
      state: {
        productId: id,
      },
    });
  };

  // Tile click — uses the linkLevel1/2/3 saved against each tile so the
  // Category page receives the same `state` shape the mega menu sends when
  // the equivalent menu item is clicked.
  const onTileClick = (tile) => {
    // Direct-URL override — when set, ignore the menu-link fields entirely.
    const directUrl = typeof tile.linkUrl === "string" ? tile.linkUrl.trim() : "";
    if (directUrl) {
      if (/^https?:\/\//i.test(directUrl)) {
        window.location.href = directUrl;
      } else {
        const internal = directUrl.startsWith("/") ? directUrl : `/${directUrl}`;
        navigate(normalizeProductPath(internal));
      }
      return;
    }
    const leaf = tile.linkLevel3 || tile.linkLevel2 || tile.linkLevel1 || tile.title;
    if (!leaf || leaf === "undefined") return;
    const isBranded = tile.menuGroup === "branded_jewellery";
    const state = {
      menuLevel1: tile.linkLevel1 || null,
      menuLevel2: tile.linkLevel2 || null,
      menuLevel3: tile.linkLevel3 || null,
      menuGroup: tile.menuGroup,
      ...(isBranded ? { brandName: tile.linkLevel1 } : {}),
    };
    navigate(
      buildCategoryPath(
        isBranded
          ? {
              brandName: tile.linkLevel1,
              menuLevel2: tile.linkLevel2,
              menuLevel3: tile.linkLevel3,
            }
          : {
              menuLevel1: tile.linkLevel1,
              menuLevel2: tile.linkLevel2,
              menuLevel3: tile.linkLevel3,
            },
      ),
      { state },
    );
  };

  const Colloection = (item) => {
    navigate(buildCategoryPath({ menuLevel1: item?.Data_Name }), {
      state: {
        item: item?.Data_Name,
        id: item?._id,
      },
    });
  };

  let settingsCat = {
    infinite: true,
    speed: 2500,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 100,

    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1.2,
        },
      },
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  };

  let settings = {
    dots: true,
    infinite: true,
    speed: 2500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 100,
    waitForAnimate: false,

    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1.3,
        },
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1.2,
        },
      },
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  };

  let settings2 = {
    dots: true,
    infinite: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 100,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const HomeArrowLeft = ({ onClick }) => (
    <button type="button" className={styles.carouselArrow + " " + styles.carouselArrowLeft} onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
  );

  const HomeArrowRight = ({ onClick }) => (
    <button type="button" className={styles.carouselArrow + " " + styles.carouselArrowRight} onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 6 15 12 9 18" />
      </svg>
    </button>
  );

  /* One product rail.
   *
   * On a phone this is a NATIVE scroller with scroll-snap, not react-slick.
   * Slick tracks the finger in JavaScript and moves the track by transform on
   * every touchmove, so the gesture runs on the main thread and stutters —
   * and `touch-action: pan-y` hands it the whole horizontal gesture, so the
   * browser cannot help. A real scroller gets momentum, rubber-banding and
   * compositor-driven frames for free, which is what "smooth" actually means
   * on a touch screen.
   *
   * Desktop keeps the slider, where the arrows and the 5–6-up layout matter
   * and there is no finger to track.
   *
   * A function, not a component: declared inside Home, a component would be a
   * new type on every render and React would remount the rail — throwing the
   * scroller back to the start mid-swipe.
   */
  const renderProductRail = (items) => {
    if (!items?.length) return null;
    return (
      <>
        <div className={styles.mobileRail}>
          {items.map((item, index) => (
            <div key={item._id || index} className={styles.mobileRailItem}>
              <ProductCard item={item} />
            </div>
          ))}
        </div>
        <div className={styles.desktopRail}>
          <Slider {...getHomeCarouselSettings(items.length)} className={styles.main}>
            {items.map((item, index) => (
              <div key={item._id || index} className={styles.slideItem}>
                <ProductCard item={item} />
              </div>
            ))}
          </Slider>
        </div>
      </>
    );
  };
  const getHomeCarouselSettings = (count) => ({
    dots: false,
    infinite: count > 6,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: true,
    draggable: count > 6,
    prevArrow: count > 6 ? <HomeArrowLeft /> : <></>,
    nextArrow: count > 6 ? <HomeArrowRight /> : <></>,
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, infinite: count > 4 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, infinite: count > 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, arrows: false, infinite: count > 2 },
      },
      {
        breakpoint: 426,
        settings: { slidesToShow: 1.5, arrows: false, infinite: count > 1 },
      },
      {
        breakpoint: 376,
        settings: { slidesToShow: 1.3, arrows: false, infinite: count > 1 },
      },
    ],
  });

  return (
    <div>
      <Row justify="center" className={styles.mainLine}>
        <Col
          xs={24}
          md={24}
          lg={24}
          xl={24}
          xxl={24}
          className={styles.bannerFull}
        >
          <BannerCarousel
            slides={(banner || []).map(b => ({
              src: b?.banner_Image,
              link: b?.Banner_link,
              title: b?.Banner_Title || "",
              subtitle: b?.Banner_Subtitle || "",
            }))}
            transition={bannerTransition}
            intervalMs={bannerIntervalMs}
            onClick={(s) => {
              if (s?.link && s.link !== "undefined") {
                if (/^https?:\/\//i.test(s.link)) window.location.href = s.link;
                else navigate(s.link.startsWith("/") ? s.link : `/${s.link}`);
              }
            }}
            className={styles.bannercourasel}
          />
        </Col>

        <Col xs={24} md={24} lg={24} xl={24} xxl={24} className={styles.categorySection}>
          <div className={styles.sectionHeadingBlock}>
            <span className={styles.featureEyebrow}>Browse By Category</span>
            <h2 className={styles.featureHeading}>Explore The Range</h2>
            <div className={styles.featureHeadingLine} />
          </div>
          <Row gutter={[8, 8]}>
            {visibleTiles.map((tile) => (
              <Col xs={12} sm={8} md={6} lg={6} xl={6} key={tile.position}>
                <div className={styles.Catagory} onClick={() => onTileClick(tile)} role="button" tabIndex={0}>
                  <img src={tile.image} alt={tile.title || tile.linkLabel} />
                  <div className={styles.overlay}></div>
                  <div className={styles.tileCaption}>
                    <h3 className={styles.tileTitle}>{tile.title || tile.linkLabel}</h3>
                    <div className={styles.tileRule}>
                      <span className={styles.tileRuleLine} />
                      <span className={styles.tileRuleStar}>✦</span>
                      <span className={styles.tileRuleLine} />
                    </div>
                    {tile.subtitle && <p className={styles.tileSubtitle}>{tile.subtitle}</p>}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Col>

        <Col xs={24}>
          <div className={styles.sectionDivider} />
        </Col>

        <Col xs={24} md={24} lg={24} xl={24} xxl={24} className={styles.sectionPad}>
          <div className={styles.sectionHeadingBlock}>
            <span className={styles.featureEyebrow}>Fresh From The Workshop</span>
            <h2 className={styles.featureHeading}>New Arrivals</h2>
            <div className={styles.featureHeadingLine} />
          </div>
          {renderProductRail(productList3)}
        </Col>

        <FeatureSection />

        <Col xs={24} md={24} lg={24} xl={24} xxl={24} className={`${styles.sectionPad} ${styles.sectionSpacing}`}>
          <div className={styles.sectionHeadingBlock}>
            <span className={styles.featureEyebrow}>Curated For You</span>
            <h2 className={styles.featureHeading}>Trending Now</h2>
            <div className={styles.featureHeadingLine} />
          </div>
          {renderProductRail(productList2)}
        </Col>

        {/* <Col
          xs={24}
          md={24}
          lg={24}
          xl={24}
          xxl={24}
          style={{ paddingBottom: 50, paddingTop: 20 }}
        >
          <Slider {...settingsCat} className={styles.handlecourasel}>
            {brands?.map((brand, index) => (
              <div key={index}>
                <div
                  style={{
                    height: 50,
                    width: 200,
                    border: "1px solid #e9e9e9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px 0",
                  }}
                >
                  <img
                    style={{
                      objectFit: "contain",
                      height: 40,
                      width: "80%",
                    }}
                    src={brand}
                    alt={brand}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </Col> */}

        <Col xs={24} className={styles.reviewSection}>
          <div className={styles.reviewContainer}>
            <div className={styles.sectionHeadingBlock}>
              <span className={styles.featureEyebrow}>Customer Reviews</span>
              <h2 className={styles.featureHeading}>What Our Customers Say</h2>
              <div className={styles.featureHeadingLine} />
            </div>

            <Row gutter={[20, 20]} justify="center">
              <Col xs={24} sm={22} md={8}>
                <div className={styles.reviewCard}>
                  <p className={styles.reviewText}>
                    The Diamond Counter is my go-to for bespoke pieces. The
                    craftsmanship is outstanding, and their custom diamond
                    letter pendants have impressed every client I’ve worked
                    with. Reliable, professional, and always high-quality!
                  </p>

                  <div className={styles.reviewUser}>
                    <div className={styles.avatar}>J</div>

                    <div>
                      <h4>James</h4>
                      <span>Wednesday, Nov 13, 2024</span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={24} sm={22} md={8}>
                <div className={styles.reviewCard}>
                  <p className={styles.reviewText}>
                    I recently ordered a custom diamond tennis bracelet from
                    The Diamond Counter, and it was absolutely stunning. The
                    craftsmanship and quality were impeccable, and my client
                    couldn’t have been happier. Truly a reliable partner for
                    bespoke jewellery!
                  </p>

                  <div className={styles.reviewUser}>
                    <div className={styles.avatar}>S</div>

                    <div>
                      <h4>Sarah E.</h4>
                      <span>Saturday, Dec 14, 2024</span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={24} sm={22} md={8}>
                <div className={styles.reviewCard}>
                  <p className={styles.reviewText}>
                    Exceptional service from start to finish. I had a bespoke
                    engagement ring made and the team guided me through every
                    step. The diamond quality is second to none and the
                    finished piece was even more beautiful than I imagined.
                  </p>

                  <div className={styles.reviewUser}>
                    <div className={styles.avatar}>R</div>

                    <div>
                      <h4>Rahul M.</h4>
                      <span>Friday, Jan 24, 2025</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        {/*
        <Col xs={24} md={24} lg={24} xl={24} xxl={24} className={styles.aboutSection}>
          <div className={styles.sectionWide}>
            <Row gutter={[60, 40]} align="middle">
              <Col xs={24} lg={12}>
                <div className={styles.imageCompositor}>
                  <div className={styles.mainImageWrapper}>
                    <img
                      src={about}
                      alt="Crafting Diamonds"
                      className={styles.mainImage}
                    />
                  </div>

                  <div className={styles.floatingBadge}>
                    <Text className={styles.badgeYear}>EST.</Text>
                    <Text className={styles.badgeDate}>1998</Text>
                  </div>
                </div>
              </Col>

              <Col xs={24} lg={12}>
                <Space
                  direction="vertical"
                  size="large"
                  className={styles.contentArea}
                >
                  <Paragraph className={styles.description}>
                    At Exclusive Diamond, we don't just sell jewelry; we
                    preserve memories. Every stone is hand-selected by our
                    master gemologists, ensuring that each cut reflects the
                    maximum brilliance possible.
                  </Paragraph>

                  <Paragraph className={styles.description}>
                    Our signature "Nude Cut" collection focuses on the raw,
                    aesthetic beauty of diamonds, set in ethically sourced
                    metals that celebrate your unique story with timeless
                    elegance.
                  </Paragraph>

                  <div className={styles.statsRow}>
                    <div className={styles.statItem}>
                      <Title level={3} className={styles.statNum}>
                        25+
                      </Title>
                      <Text className={styles.statLabel}>Years of Mastery</Text>
                    </div>
                    <div className={styles.statItem}>
                      <Title level={3} className={styles.statNum}>
                        10k+
                      </Title>
                      <Text className={styles.statLabel}>Unique Designs</Text>
                    </div>
                  </div>

                  <Button size="large" className={styles.luxuryButton}>
                    Explore Our Story
                  </Button>
                </Space>
              </Col>
            </Row>
          </div>
        </Col>
        */}

        <section className={styles.parallaxContainer}>
          {/* Overlay creates contrast so text is readable on the image */}
          <div className={styles.darkOverlay}></div>

          <div className={styles.centerContent}>
            <Text className={styles.miniTitle}>
              Trusted. United. Recognised.
            </Text>

            <img
              src={najLogo}
              alt="National Association of Jewellers Logo"
              style={{ height: 200, maxWidth: "80%" }}
            />

            <Title
              level={1}
              className={[styles.mainHeading, styles.whiteColor]}
            >
              The Voice of the Jewellery Industry
            </Title>

            <p className={styles.tagline}>
              Representing excellence, integrity, and professionalism across the
              jewellery trade.
            </p>

          </div>
        </section>

        {/* Trustpilot Section */}
        <Col xs={24} className={styles.trustpilotSection}>
          <div className={styles.trustpilotInner}>
            <div className={styles.trustpilotTop}>
              <div className={styles.trustpilotStars}>
                {[...Array(5)].map((_, i) => (
                  <div key={i} className={styles.starBox}>
                    <svg width="32" height="32" viewBox="0 0 24 24">
                      <polygon
                        points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                        fill="#00B67A"
                      />
                    </svg>
                  </div>
                ))}
              </div>
              <div className={styles.trustpilotScore}>
                <span className={styles.scoreValue}>4.9</span>
                <span className={styles.scoreTotal}>/ 5</span>
              </div>
            </div>

            <p className={styles.trustpilotRating}>
              Rated <strong>Excellent</strong>
            </p>

            <div className={styles.trustpilotDivider} />

            <div className={styles.trustpilotBottom}>
              <span className={styles.trustpilotLabel}>Based on</span>
              <strong className={styles.trustpilotCount}>100+</strong>
              <span className={styles.trustpilotLabel}>verified reviews on</span>
              <span className={styles.trustpilotBrand}>
                <svg width="14" height="14" viewBox="0 0 24 24" style={{ marginRight: 3, position: "relative", top: 2 }}>
                  <polygon
                    points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                    fill="#00B67A"
                  />
                </svg>
                Trustpilot
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default memo(Home);
